<template>
  <div class="m-4">
    <div class="flex flex-row gap-2 items-center my-2">
      <button class="rounded-full bg-paleta-3" @click="volver">
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="h-8 w-8 p-1" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path
            fill="currentColor"
            d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
          ></path>
        </svg>
      </button>
      <div class="text-white text-base">Paso 1 >> Seleccionar carrera</div>
    </div>
    <div v-for="carrera in carreras" :key="carrera.id" @click="click(carrera.id)" class="flex flex-row p-2 bg-teal-500 rounded-md my-1 w-full gap-3 shadow-xl">
      <div class="flex flex-col self-center">
        <div class="text-xs text-white self-center">CARR</div>
        <div class="text-left text-white text-base font-bold self-center">{{ carrera.numero }}</div>
      </div>
      <div class="flex flex-col">
        <div class="text-left text-white text-sm">{{ carrera.hipodromo }}</div>
        <div class="flex flex-row">
          <div class="text-left text-white text-xs">{{ carrera.pista }} | {{ carrera.premio }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { format, parseISO } from "date-fns";
import differenceInMinutes from "date-fns/differenceInMinutes";

export default {
  data: function() {
    return {
      format,
      parseISO,
      differenceInMinutes
    };
  },
  created() {
    this.$store.dispatch("cargarCarrerasResultado");
  },
  methods: {
    volver() {
      this.$router.go(-1);
    },
    click: function(carreraId) {
      this.$store.dispatch("cargarSportsCarrera", { carreraId });
      this.$router.push({ path: "/resultadosCarrera" });
    }
  },
  computed: {
    ...mapState({ carreras: state => state.resultados.carreras })
  }
};
</script>
